import React from 'react'
import styled from 'styled-components'

export type UsernameInitialsSize = 'sm' | 'md' | 'lg'

export interface UsernameInitialsProps extends React.HTMLAttributes<HTMLDivElement> {
  initials: string
  size?: UsernameInitialsSize
  background?: string
  color?: string
}

const sizeStyles: Record<
  UsernameInitialsSize,
  { box: string; fontSize: string }
> = {
  sm: { box: '22px', fontSize: '10px' },
  md: { box: '28px', fontSize: '13px' },
  lg: { box: '30px', fontSize: '11px' },
}

// Canonical blue tile: #5072a4 on #5072a426 — the Nav bar Settings button's
// avatar (approximates sutra/tokens/colors accents.reflectionBlue[500]).
const DEFAULT_COLOR = '#5072a4'
const DEFAULT_BACKGROUND = '#5072a426'

const InitialsBlock = styled.div<{
  $size: UsernameInitialsSize
  $background: string
  $color: string
}>`
  width: ${({ $size }) => sizeStyles[$size].box};
  height: ${({ $size }) => sizeStyles[$size].box};
  flex-shrink: 0;
  border-radius: 6px;
  background: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $size }) => sizeStyles[$size].fontSize};
  font-weight: 600;
  text-transform: uppercase;
`

export const UsernameInitials = React.forwardRef<
  HTMLDivElement,
  UsernameInitialsProps
>(
  (
    {
      initials,
      size = 'md',
      background = DEFAULT_BACKGROUND,
      color = DEFAULT_COLOR,
      ...rest
    },
    ref,
  ) => (
    <InitialsBlock
      ref={ref}
      $size={size}
      $background={background}
      $color={color}
      {...rest}
    >
      {initials}
    </InitialsBlock>
  ),
)

UsernameInitials.displayName = 'UsernameInitials'
